/**
 * Debounce function for animation
 *
 * @param callback
 * @param wait
 * @param context
 * @return {Function}
 *
 * Source: https://gist.github.com/beaucharman/1f93fdd7c72860736643d1ab274fee1a
 *
 * Usage:
 * const handleScroll = debounce((e) => {
 *   console.log('Window scrolled.');
 * }, 100);
 *
 * window.addEventListener('scroll', handleScroll);
 */
export function debounce(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;
    const later = () => callback.apply(context, callbackArgs);
    return function () {
        callbackArgs = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

/**
 * Throttle function for animation
 *
 * @param callback
 * @param wait
 * @param context
 * @return {Function}
 *
 * Source: https://gist.github.com/beaucharman/e46b8e4d03ef30480d7f4db5a78498ca
 *
 * Usage:
 * const handleKeydown = throttle((e) => {
 *   console.log(e.target.value)
 * }, 300)
 *
 * input.addEventListener('keydown', handleKeydown)
 */
export function throttle(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;
    const later = () => {
        callback.apply(context, callbackArgs);
        timeout = null;
    };
    return function () {
        if (!timeout) {
            callbackArgs = arguments;
            timeout = setTimeout(later, wait);
        }
    };
}

/**
 * Get the position of an node element within his parent
 *
 * Replace jQuery function: jQuery.index()
 *
 * @param elm Node element
 * @returns {number}
 */
export function getNodeindex(elm) {
    // return [...elm.parentNode.children].findIndex(c => c == elm);
    // or
    return [...elm.parentNode.children].indexOf(elm);
}

/**
 * Get the scroll position
 *
 * Replace jQuery function: jQuery(window).scrollTop()
 *
 * @returns {Number|number}
 */
export function getScrollPosition() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

/**
 * Detecting CSS Animation Completion
 */
export function detectTransitionEnd() {
    const el          = document.createElement('fakeelement'),
          transitions = {
              'transition': 'transitionend',
              'OTransition': 'oTransitionEnd',
              'MozTransition': 'transitionend',
              'WebkitTransition': 'webkitTransitionEnd'
          };
    let t;

    for (t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
}

/**
 * Creating, reading and checking cookies
 */


// The parameters of the setCookie function are:
// the name of the cookie (cname),
// the value of the cookie (cvalue),
// and the number of days until the cookie should expire (exdays).
export function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}


// The function getCookie returns the value of a specified cookie:
export function getCookie(cname) {
    let name = cname + '=';
    let cookiesArr = document.cookie.split(';');
    for (let i = 0; i < cookiesArr.length; i++) {
        let c = cookiesArr[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

// the checkCookie function checks if a cookie is set. Return true if yes, false otherwise
export function checkCookie(cname) {
    let cookiename = getCookie(cname);

    if (cookiename !== '') {
        return true;
    } else {
        return false;
    }
}

// function used for layout construction inside popins
export function html(literalSections, ...substs) {

    function htmlEscape(str) {
        return str.replace(/&/g, '&amp;')
        .replace(/>/g, '&gt;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#96;');
    }

    let raw = literalSections.raw;

    let result = '';

    substs.forEach((subst, i) => {
        let lit = raw[i];

        if (Array.isArray(subst)) {
            subst = subst.join('');
        }

        if (lit.endsWith('$')) {
            subst = htmlEscape(subst);
            lit = lit.slice(0, -1);
        }
        result += lit;
        result += subst;
    });

    result += raw[raw.length - 1];

    return result;
}



// WEBPACK FOOTER //
// ./src/js/helpers/utils.js